<script>
import Loading from 'vue-loading-overlay';
import service from '@/service';
import settings from '@/settings.js';

export default {
	components: {
		Loading
	},
	methods: {
		showModal: function (data) {
			console.log('data', data);
			this.mapa_id = data.mapa_id;
			this.ogrodje = data.ogrodje;
			this.datum_izstavitve_racuna = data.datum_izstavitve_racuna;
			this.$refs.modal.show();
		},
		click_okModal: function (evt) {
			evt.preventDefault();
			this.isLoading = true;
			service.MapaIzstaviRacun(this.mapa_id)
				.then(response => {
					if (response['message'] === 'success') {
						this.isLoading = false;
						this.$refs.modal.hide();
						this.$emit('izstavitevRacuna_success');
					} else {
						this.isLoading = false;
						this.showError('Neveljaven odziv strežnika!');
						console.error('Neveljaven response message: ' + response['message']);
					}
				})
				.catch(error => {
					this.isLoading = false;
					if (error.response) {
						// Request made and server responded
						if (error.response.data.message === settings.errorMessages.serverSideValidationError) {
							this.showError('Napaka pri validaciji na strežniku!');
							console.error(error.response.data.message + ': ', error.response.data.errors);
						} else if (error.response.data.message === settings.errorMessages.notSavedError) {
							this.showError('Napaka pri shranjevanju izstavitve računa!');
							console.error(error.response.data.message);
						} else if (error.response.data.message === settings.errorMessages.PDOException) {
							this.showError('Napaka na strežniku!');
							console.error(error.response.data.message);
						} else {
							this.showError('Neznana napaka na strežniku!');
							console.error(error.response.data.message);
						}
					} else if (error.request) {
						// The request was made but no response was received
						console.log('The request was made but no response was received:', error.request);
					} else {
						// Something happened in setting up the request that triggered an Error
						console.log('Something happened in setting up the request that triggered an Error:', error.message);
					}
				});
			console.log('ok click');
		},
		click_cancelModal: function (evt) {
			evt.preventDefault();
			this.$refs.modal.hide();
			setTimeout(() => {
				console.log('clear');
				this.clearModal();
			}, 300);
		},
		clearModal: function () {
			this.message.type = null;
			this.message.text = null;
			this.isLoading = false;
			this.mapa_id = null;
			this.ogrodje = null;
			this.datum_izstavitve_racuna = null;
		},
		showError: function (message) {
			if (message) {
				this.message.type = this.ACTION_TYPE_ERROR;
				this.message.text = message;
			} else {
				this.message.type = null;
				this.message.text = null;
			}
		}
	},
	data: function () {
		return {
			isLoading: false,
			message: {
				type: null,
				text: null
			},
			ACTION_TYPE_ERROR: 'ERROR',
			mapa_id: null,
			ogrodje: '',
			datum_izstavitve_racuna: null
		}
	},
	computed: {
		buttonIzdajDisabled () {
			if (this.datum_izstavitve_racuna) {
				return true;
			}
			return false;
		}
	},
	created () {
	}
}
</script>
<template>
	<b-modal ref="modal" @hidden="clearModal" title="Izstavitev računa" class="modal-primary" ok-title="Izstavi" cancel-title="Prekliči" size="sm">
		<loading :active.sync="isLoading"></loading>
		<b-row>
			<b-col>
				<b-form-group label="Šasija:">
					<b-form-input type="text" v-model="ogrodje" disabled></b-form-input>
				</b-form-group>
			</b-col>
		</b-row>
		<b-alert :variant="message.type && message.type === ACTION_TYPE_ERROR ? 'danger' : 'primary'" :show="message.text && message.text !== ''">{{ message.text }}</b-alert>
		<template slot="modal-footer">
			<b-container fluid class="p-0">
				<b-row>
					<b-col align-self="end" class="ma_pos">
						<b-button variant="secondary" @click.stop="click_cancelModal($event)">Prekliči</b-button>
						<b-button variant="primary" @click.stop="click_okModal($event)" :disabled="buttonIzdajDisabled">Izstavi račun</b-button>
					</b-col>
				</b-row>
			</b-container>
		</template>
	</b-modal>
</template>
<style scoped>
.ma_pos {
	text-align: end;
}
</style>


// WEBPACK FOOTER //
// src/components/Modals/IzstavitevRacunaModal.vue